// src/pages/pmstudio/blocks/Page.jsx
import React from "react";

function Page({ children }) {
  return (
    <div
      className="pm-page"
      contentEditable
      suppressContentEditableWarning
    >
      {children}
    </div>
  );
}

export default Page;
